/*
 * @Author: jingyu.yang
 * @Date: 2021-12-17 10:04:45
 * @Last Modified by: jingyu.yang
 * @Last Modified time: 2022-03-23 11:38:32
 */
// * NOT_UPLOAD(0,"未上传"),
// * UPLOAD_SUCCESS(1,"上传成功"),
// * UPLOAD_FAIL(2,"上传失败"),
// * UPLOADING(3,"上传中"),
// * TRANSCODING(4,"转码中"),
// * TRANSCODE_SUCCESS(5,"转码成功"),
// * TRANSCODE_FAIL(6,"转码失败");
import SparkMD5 from "spark-md5";
import {
  getFileName,
  getExtension,
  getParameter,
  dateFormat,
  s2hms,
  uuid,
} from "@/utils/global";
import aw from "@/utils/aw";
import { groupingData } from "./utils";
import { upload, uploadFinish } from "@/api/docRequest/api";
import {
  task,
  resourceList,
  resourceBind,
  resourceDeleteBind,
} from "@/api/liveRequest/resource";
const styles = [
  "prepare",
  "transcoding",
  "fail",
  "uploading",
  "transcoding",
  "complete",
  "transcodingFail",
];
export default {
  name: "FileUpload",
  props: {
    fileTypes: {
      type: Array,
      default: () => [
        "ppt",
        "pptx",
        "pdf",
        "jpg",
        "png",
        "bmp",
        "jpeg",
        "doc",
        "docx",
        "txt",
        "wps",
        "dps",
      ],
    },
    fileSize: {
      type: Number,
      default: 0,
    },
    // 0=文档 1=插播 2=暖场 3=伪直播
    mode: {
      type: Number,
      default: 0,
    },
    // 1-仅绑定到场次, 2-同时绑定到场次和直播间
    bind: {
      type: Number,
      default: 1,
    },
    appName: {
      type: String,
      default: "cloud_webcast",
    },
  },
  data() {
    return {
      statusText: {
        prepare: this.$t("message.准备中"),
        complete: this.$t("message.上传成功"),
        uploading: this.$t("message.上传中"),
        transcoding: this.$t("message.转码中"),
        fail: this.$t("message.上传失败"),
        transcodingFail: this.$t("message.转码失败"),
        stop: this.$t("message.已暂停"),
      },
      piece: 1024 * 1024 * 5, //分片大小
      sliceOk: [],
      lastTime: new Date().getTime(), //上次上传完时间
      roomId: getParameter("roomId"),
      liveId: getParameter("liveId"),
      allFiles: [], //所有的文件列表
      loadingFile: [], // 正在上传的，用于判断是否有上传中的文件，转码完成删除
      waitUploadFiles: [], //等待中可以上传的文件
      fileStop: false,
      uploadFinish: 0,
      listLoading: false,
      isDestroy: false,
    };
  },
  computed: {
    scope() {
      return `${this.appName}_localFiles_${this.liveId}_${this.uid}_${this.mode}`;
    },
  },
  watch: {
    allFiles: {
      deep: true,
      handler() {
        const unbinds = this.allFiles.filter((v) => v.bindType === -1);
        sessionStorage.setItem(this.scope, JSON.stringify(unbinds));
      },
    },
    liveStartStatus(n, o) {
      if (o === 2 && n !== 2) {
        sessionStorage.removeItem(this.scope);
      }
    },
  },
  created() {
    if (!window.___preUpload___) {
      window.___preUpload___ = {};
    }
  },
  beforeDestroy() {
    this.isDestroy = true;
  },
  methods: {
    /**
     * 选择文件
     * @param {*} files
     */
    fileChange(files) {
      files = Array.from(files);
      files.forEach((item) => {
        let fileSuffix = item.name.split(".").pop().toLowerCase();
        if (this.fileTypes.includes(fileSuffix) || this.localTrans) {
          const time = dateFormat(new Date(), "YYYY-MM-DD HH:mm");
          const _uuid = uuid(15, 62);
          let fileObject = {
            file: item,
            bindType: -1,
            fileSize: Math.ceil(item.size / 1024 / 1024) + "MB",
            date: time,
            ct: time,
            fileType: getExtension(item.name),
            fileNoSuffix: getFileName(item.name),
            filename: item.name,
            fileSuffix: item.name.split(".").pop(),
            roomId: this.roomId,
            stop: false,
            percent: "0",
            percentText: Math.ceil(item.size / 1024 / 1024) + "MB",
            uniqueIdentifier: "",
            uuid: _uuid,
          };
          this.setStyle(fileObject, 0);
          this.allFiles.unshift(fileObject);
          window.___preUpload___[_uuid] = true;
          if (item.size === 0) {
            this.failFiles(fileObject);
            this.waitPop();
            return;
          }
          this.computeMD5(fileObject);
        } else {
          this.$emit("on-error", {
            type: "fileType",
            file: item,
          });
          return;
        }
      });
      this.$refs.fileUpload.value = "";
    },
    /**
     * 计算文件MD5
     * @param {*} fileObject
     */
    computeMD5(fileObject) {
      let chunkSize = 1024 * 1024 * 100,
        chunks = Math.ceil(fileObject.file.size / chunkSize),
        currentChunk = 0,
        spark = new SparkMD5.ArrayBuffer(),
        fileReader = new FileReader();

      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice;

      let time = new Date().getTime();

      let loadNext = () => {
        let start = currentChunk * chunkSize,
          end =
            start + chunkSize >= fileObject.file.size
              ? fileObject.file.size
              : start + chunkSize;

        let chunk = blobSlice.call(fileObject.file, start, end);
        fileReader.readAsArrayBuffer(chunk);
      };

      fileReader.onload = (e) => {
        spark.append(e.target.result); // Append array buffer
        currentChunk++;

        if (currentChunk < chunks) {
          console.log(
            `第${currentChunk}分片解析完成, 开始第${
              currentChunk + 1
            } / ${chunks}分片解析`
          );
          loadNext();
        } else {
          console.log("finished loading");
          let md5 = spark.end(); //得到md5
          fileObject.uniqueIdentifier = md5; //将文件md5赋值给文件唯一标识
          console.log(
            `MD5计算完成：${
              fileObject.file.name
            } \nMD5：${md5} \n分片：${chunks} 大小:${
              fileObject.file.size
            } 用时：${new Date().getTime() - time} ms`
          );
          spark.destroy(); //释放缓存
          this.waitUploadFiles.push(fileObject);
          if (!this.loadingFile.length) {
            this.upLoadTask(fileObject);
          }
        }
      };

      fileReader.onerror = () => {
        console.warn("oops, something went wrong.");
        this.failFiles(fileObject);
        this.waitPop();
      };

      loadNext();
    },

    /**
     * 获取文件fileToken
     * @param {*} fileObject
     */
    upLoadTask(fileObject) {
      let param = {
        name: fileObject.file.name,
        md5: fileObject.uniqueIdentifier,
        size: fileObject.file.size,
        roomId: this.roomId,
        type: this.mode, // 0 文档 插播 1
        source: 2, // 1 后台上传 2 直播间上传
        liveId: getParameter("liveId"),
        appName: this.appName,
      };
      this.waitToLoading(fileObject);
      task(param)
        .then(async (resp) => {
          if (resp.code === 200 && resp.data?.status === 0) {
            const data = resp.data?.data;
            if (data?.space) {
              if (data.space?.left < 0) {
                this.$emit("on-error", {
                  type: "leftSize",
                  file: fileObject,
                  resp,
                });
              }
            }
            fileObject.bindType = 1;
            fileObject.srcFileId = data.srcFileId;
            fileObject.fileToken = data.fileToken;
            fileObject.percentText =
              Math.ceil(fileObject.file.size / 1024 / 1024) + "MB";

            // 已经传过，直接从列表取
            if (data.status === 1) {
              this.setStyle(fileObject, 3);
              fileObject.percent = "20%";
              this.waitPop();
            } else {
              this.setStyle(fileObject, 3);
              this.uploadFinish = 0;
              this.sliceFile(fileObject);
              this.loadingFile.push(fileObject);
            }
            // 存入本地列表
            this.lastTime = new Date().getTime();
          } else {
            console.log("preupload not 0");
            this.failFiles(fileObject);
          }
        })
        .catch((e) => {
          console.log("进入catch preupload", e);
          this.failFiles(fileObject);
          this.waitPop();
        });
    },
    waitPop() {
      if (!this.waitUploadFiles.length) return;
      this.upLoadTask(this.waitUploadFiles.pop());
    },

    failFiles(fileObject) {
      fileObject.load = false;
      this.setStyle(fileObject, 2);
    },

    waitToLoading(fileObject) {
      this.waitUploadFiles = this.waitUploadFiles.filter(
        (v) => v.uuid !== fileObject.uuid
      );
    },

    /**
     * 大文件上传分片
     * @param {*} fileObject
     */
    async sliceFile(fileObject) {
      let totalSize = fileObject.file.size; // 文件总大小
      let chunks = Math.ceil(totalSize / this.piece);
      let start = 0; // 每次上传的开始字节
      let end = start + this.piece; // 每次上传的结尾字节
      let chunk = 0;
      fileObject.load = true;
      const data = [];
      while (start < totalSize) {
        let sliceUpload = { key: start, value: false };
        this.sliceOk.push(sliceUpload);
        if (!this.fileStop) {
          chunk = chunk + 1;
          data.push({ fileObject, start, chunks, chunk });
        }
        start = end;
        end = start + this.piece;
      }
      const iterator = this.createIterator(groupingData(data));
      for (let item of iterator) {
        try {
          await Promise.all(item);
        } catch (err) {
          this.setStyle(fileObject, 2);
        }
      }
    },

    *createIterator(items) {
      for (let i = 0; i < items.length; i++) {
        yield items[i].map((v) =>
          this.uploadFile(v.fileObject, v.start, v.chunks, v.chunk)
        );
      }
    },

    /**
     * 上传文件
     * @param {*} fileObject
     * @param {*} start
     */
    async uploadFile(fileObject, start, chunks, chunk) {
      if (this.isDestroy) {
        this.failFiles(fileObject);
        return;
      }
      let end = start + this.piece;
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice; //兼容方式获取slice方法
      let blob = blobSlice.call(fileObject.file, start, end);
      let fd = new FormData();
      fd.append("file", blob);

      let parms = {
        start: start,
        size: this.piece,
        token: fileObject.fileToken,
      };

      fd.append("break_upload_param", JSON.stringify(parms));
      let config = this.uploadConfig(fileObject, start, chunks, chunk);

      try {
        const { status, data } = await upload(fd, config);
        if (status === 0) {
          let toFinish = true;
          this.sliceOk.map((item) => {
            if (item.key === data.start) {
              item.value = true;
            }
            toFinish = item.value && toFinish;
          });
          if (toFinish) {
            this.finish(fileObject);
            this.sliceOk = [];
          }
          this.uploadFinish = this.uploadFinish + this.piece;
        } else {
          this.failFiles(fileObject);
          this.waitPop();
        }
      } catch (error) {
        this.failFiles(fileObject);
        this.waitPop();
      }
    },

    uploadConfig(fileObject, start, chunks, chunk) {
      return {
        onUploadProgress: (progressEvent) => {
          fileObject.loadArr = fileObject.loadArr || [];
          fileObject.loadArr[chunk] = progressEvent.loaded;
          const loadSize = fileObject.loadArr.reduce(
            (prev = 0, current = 0) => prev + current,
            0
          );
          let percent = Math.min(
            Math.round((loadSize / fileObject.file.size) * 20),
            20
          );
          fileObject.percent = percent + "%";
          let leftTime = this.processHandle(progressEvent, fileObject);
          fileObject.leftTime = leftTime;
          fileObject.load = true;
        },
      };
    },

    processHandle(event, fileObject) {
      let nowTime = new Date().getTime();
      let intervalTime = (nowTime - this.lastTime).toFixed(0) / 1000;
      let intervalSize = event.loaded;
      let speed = intervalSize / intervalTime;
      let leftTime = Math.max((fileObject.file.size - event.loaded) / speed, 0);
      return s2hms(leftTime);
    },
    /**
     * 文件上传结束
     * @param {*} fileObject
     */
    finish(fileObject) {
      let param = {
        token: fileObject.fileToken,
        md5: fileObject.uniqueIdentifier,
        size: fileObject.file.size,
        appName: this.appName,
      };
      fileObject.percentText =
        Math.ceil(fileObject.file.size / 1024 / 1024) + "MB";
      uploadFinish(param)
        .then(({ status, data }) => {
          console.log("finish");
          if (status === 0) {
            fileObject.srcFileId = data.srcFileId;
            this.setStyle(fileObject, 3)
          } else {
            console.log("finish失败");
            this.failFiles(fileObject);
          }
          this.delLoadingFile(fileObject);
          this.waitPop();
          fileObject.percent = "";
          fileObject.leftTime = "";
          fileObject.load = false;
          fileObject.stop = false;
        })
        .catch(() => {
          console.log("进入catch finish");
          this.failFiles(fileObject);
          this.delLoadingFile(fileObject);
          this.waitPop();
        });
    },
    // 删除目标资源
    delFile(row) {
      this.delLoadingFile(row);
      this.deleteFile(row);
    },
    // 从上传中数组中移除资源
    delLoadingFile(item) {
      this.loadingFile = this.loadingFile.filter((v) => v.uuid !== item.uuid);
    },
    setStyle(item, status) {
      item.status = status;
      item.style = styles[status];
      item.statusText = this.statusText[styles[status]];
    },
    // 获取资源列表
    async getLists() {
      if (this.listLoading) return;
      this.listLoading = true;
      let locals = JSON.parse(sessionStorage.getItem(this.scope) || "[]");
      console.log(locals, "locals getLists");
      const [err, { code, data }] = await aw(resourceList(this.mode), "code");
      this.listLoading = false;
      if (err !== null || code !== 200) return;
      const remotes = data.results
        ?.filter((v) => v.resource?.fileId)
        .map((v) => {
          return {
            bindType: v.bindType,
            publish: v.publish,
            record: v.record,
            resource_id: v.resource_id,
            ...v.resource,
          };
        });

      const pre = [];
      const mid = [];
      const end = [];

      // 没刷新浏览器
      if (this.allFiles.length) {
        pre.push(
          ...this.allFiles.filter(
            (v) => v.status === 0 || v.status === 3 || v.bindType === -1
          )
        );
      }
      // 刷新了浏览器
      else {
        locals.forEach((v) => {
          this.setStyle(v, 2);
          end.push(v);
        });
      }

      remotes.forEach((v) => {
        // TODO: 判断MD5去重
        if (![...pre, ...end].find((l) => l.srcFileId === v.srcFileId)) {
          if (v.status === 0 || v.status === 2 || v.status === 3) {
            this.setStyle(v, 2);
            end.push(v);
          } else if (v.status === 6) {
            this.setStyle(v, 6);
            end.push(v);
          } else {
            mid.push(v);
          }
        }
      });

      const initStyle = (arr) => {
        arr.forEach((item) => {
          this.setStyle(item, item.status);
          item.percentText = Math.ceil(item.size / 1024 / 1024) + "MB";
          item.date = item.ct;
          item.fileType = getExtension(item.filename);
          item.fileNoSuffix = getFileName(item.filename);
        });
      };
      initStyle(mid);
      this.allFiles = [...pre, ...mid, ...end];
      console.log(this.allFiles, "allFiles getLists");
    },
    // 删除文件
    async deleteFile(row) {
      const id = row.srcFileId;
      if (!id) {
        // 没有文件id，则按本地文件处理，选中文件后未调用preUpload时出现
        this.allFiles = this.allFiles.filter((v) => v.uuid !== row.uuid);
        return;
      }
      const { code, msg } = await resourceDeleteBind(id);
      if (code === 200) {
        this.allFiles = this.allFiles.filter((v) => v.srcFileId !== id);
      } else {
        this.$emit("on-error", {
          type: "fileDel",
          msg,
        });
      }
    },
    /**
     * 转码完成
     * @param {*} srcFileId
     * @param {*} status
     */
    async transcodingFile({ srcFileId, transFileId, status, cur, total }) {
      const item = this.allFiles.find((v) => v.srcFileId === srcFileId);
      console.log(item,"item")
      // 状态码已经为6时，也当转码失败处理
      if (!item || item.status === 6) return;
      if(status == 1){
        this.setStyle(item, 3);
        item.percent = "20%";
      }
      item.transFileId = transFileId;
      if (status == 4 && total !== 0) {
        console.log(cur / total, "进度");
        let percent = 20 + Math.min(Math.round((cur / total) * 79), 79);
        item.percent = percent + "%";
      }
      if (status == 5) {
        item.percent = "100%";
      }

      // 转码文件如本地无记录则按转码失败处理
      if (item.uuid && !window.___preUpload___[item.uuid]) {
        this.setStyle(item, 6);
        return;
      }

      if (status === 5) {
        item.file = {};
      }
      if(status === 5  || status === 6){
        this.setStyle(item, status);
      }
      if(status === 4){
        this.setStyle(item, 3);
      }
      
    },
    // 绑定到1场次 2场次+直播
    async bindToLiveRoom(srcFileId) {
      return await resourceBind({
        bindType: this.bind,
        resourceType: this.mode,
        resourceId: [srcFileId],
      });
    },
  },
};
